var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgU(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35.97mm",
    height: "35.973mm",
    viewBox: "0 0 35.97 35.973",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-86.523 -69.172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m119.52 69.172h-11.202c-1.5425 0.06614-2.7755 1.3335-2.7755 2.8945 0 0.01587 3e-3 0.0291 3e-3 0.04498h-3e-3v13.888c0 0.58473-0.4736 1.0583-1.0583 1.0583s-1.0583-0.4736-1.0583-1.0583v-14.1c-0.09-1.5214-1.3494-2.7252-2.8919-2.7252-0.0159 0-0.0291 0.0026-0.045 0.0026v-0.0026h-11.001c-1.6378 0-2.966 1.3282-2.966 2.966v30.038c0 1.6378 1.3282 2.966 2.966 2.966h30.038c1.6378 0 2.966-1.3282 2.966-2.966v-30.041c-8e-3 -1.6378-1.3335-2.966-2.9713-2.966z",
    fill: "#0083c1",
    strokeWidth: 0.26458
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgU);
export default __webpack_public_path__ + "static/media/u.72cdd2aa1d1ad5dda79806553ffd3fe4.svg";
export { ForwardRef as ReactComponent };